__turbopack_context__.v({
  "link": "header-navbar-module-scss-module__H85lIG__link",
  "logo": "header-navbar-module-scss-module__H85lIG__logo",
  "menuButton": "header-navbar-module-scss-module__H85lIG__menuButton",
  "root": "header-navbar-module-scss-module__H85lIG__root",
  "title": "header-navbar-module-scss-module__H85lIG__title",
});
